export default {
  "nl": {
    "button": {
      "actions": {
        "add": "Voeg toe",
        "cancel": "Annuleren",
        "create": "Maak aan",
        "delete": "Verwijderen",
        "edit": "Bewerken",
        "hide": "Verberg",
        "loading": "Laden",
        "move": "Verplaats",
        "reset": "Reset",
        "save_changes": "Wijzigingen opslaan",
        "save_message": "Bericht opslaan",
        "saving": "Opslaan",
        "share": "Deel",
        "uploadingDocuments": "Opladen documenten",
        "yes": "Ja"
      }
    }
  }
}